import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import ArrowLeftIconNew from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import ArrowRightIconNew from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LazyContext from '../LazyLoadingImage/LazyContext';
import { useSliderOverflow } from './hooks/useSliderOverflow';
import { useSliderScrollToIndex } from './hooks/useSliderScrollToIndex';
import { useSliderScrollHandler } from './hooks/useSliderScrollHandler';
import s from './Slider.scss';
const Slider = ({ smoothInitialScroll = true, scrollBy = 0.5, scrollSnap, className, height, children, disableScroll, slimSpacing, noSpacing, permArrows, dataHook, contentClassName, disableArrows, prevButtonClassName, prevIconClassName, nextButtonClassName, nextIconClassName, arrowSize = IconSize.LARGE, scrollToIndex, onScrollBiData, enableMobileSwipeLogging })=>{
    const rootRef = useRef(null);
    const contentRef = useRef(null);
    const isMobile = useContext(MobileContext);
    const overflow = useSliderOverflow(contentRef);
    const handleScrollBtnClick = useSliderScrollHandler(contentRef, scrollBy, onScrollBiData, enableMobileSwipeLogging);
    useSliderScrollToIndex(contentRef, rootRef, scrollToIndex, smoothInitialScroll);
    const withControls = !isMobile && !disableArrows;
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], overflow && s[`overflow-${overflow}`], slimSpacing && s['slim-spacing'], noSpacing && s['no-spacing'], permArrows && s['perm-arrows'], className),
        style: {
            height
        },
        ref: rootRef,
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Slider"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], disableScroll && s['no-scroll'], scrollSnap && s['scroll-snap'], contentClassName),
        ref: contentRef,
        draggable: "false"
    }, children), withControls && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: classnames(s['prev-btn'], prevButtonClassName),
        onClick: (e)=>handleScrollBtnClick(e, 'previous'),
        /**
                 * We can hide these from screen readers because they have
                 * access to all of the slider content without these buttons
                 */ "aria-hidden": 'true'
    }, /*#__PURE__*/ React.createElement(ArrowLeftIconNew, {
        withPadding: false,
        className: classnames(s['arrow-icon'], prevIconClassName),
        size: arrowSize
    })), /*#__PURE__*/ React.createElement("button", {
        className: classnames(s['next-btn'], nextButtonClassName),
        onClick: (e)=>handleScrollBtnClick(e, 'next'),
        /**
                 * We can hide these from screen readers because they have
                 * access to all of the slider content without these buttons
                 */ "aria-hidden": 'true'
    }, /*#__PURE__*/ React.createElement(ArrowRightIconNew, {
        withPadding: false,
        className: classnames(s['arrow-icon'], nextIconClassName),
        size: arrowSize
    }))))));
};
Slider.displayName = 'Slider';
export default Slider;
